export default "__VITE_ASSET__ZqeED68G__"